export default __webpack_public_path__ + "locales/lo-LA/DeleteDialog.json?hash=f77ca1228ec8083b4c475ca5ad01ef97";